import { ReactElement, ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';

type TimelineProps = {
  eventMap: Map<string, ReactNode[]>;
};

const Timeline = (props: TimelineProps): ReactElement => {
  const { eventMap } = props;

  return (
    <div className="timeline">
      {Array.from(eventMap.entries()).map(([key, value]) => (
        <Row key={key}>
          <Col className="d-flex flex-column align-items-center" md={3}>
            <div className="timeline-info">
              <div className="timeline-key">{key}</div>
              <div className="timeline-dot" />
            </div>
          </Col>
          <Col md={9}>
            <div className="timeline-entry">{value}</div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Timeline;
